import { useState } from "react";

interface Props {
  size?: number;
  showText?: boolean;
}

/**
 * Logo Formsteel. Ordem de preferência:
 * 1) PNG oficial em /logo.png (público). Se não existir (404), cai no fallback.
 * 2) SVG inline (aproximação do F cromado + texto FORMSTEEL prata).
 *
 * Para usar a logo oficial: salvar em `client/public/logo.png` (fica servido em /logo.png).
 */
export function Logo({ size = 36, showText = true }: Props) {
  const [pngOk, setPngOk] = useState(true);

  if (pngOk) {
    return (
      <img
        src="/logo.png"
        alt="Formsteel"
        style={{ height: size, width: "auto", display: "block" }}
        onError={() => setPngOk(false)}
      />
    );
  }

  // Fallback SVG inline (estilizado no espírito do logo Formsteel)
  return (
    <div className="fs-logo" style={{ height: size }}>
      <svg
        viewBox="0 0 48 52"
        xmlns="http://www.w3.org/2000/svg"
        style={{ height: "100%" }}
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="fs-chrome" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%"   stopColor="#FDFDFE" />
            <stop offset="30%"  stopColor="#D8DEE5" />
            <stop offset="50%"  stopColor="#9BA7B4" />
            <stop offset="62%"  stopColor="#5A6774" />
            <stop offset="100%" stopColor="#334155" />
          </linearGradient>
          <linearGradient id="fs-blue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%"   stopColor="#1D4E8A" />
            <stop offset="100%" stopColor="#0A2540" />
          </linearGradient>
          <filter id="fs-inner-shadow" x="-10%" y="-10%" width="120%" height="120%">
            <feGaussianBlur stdDeviation="0.3" />
          </filter>
        </defs>

        {/* Barra vertical do F */}
        <path
          d="M6 4 L18 4 L18 48 L6 48 Z"
          fill="url(#fs-chrome)"
        />
        {/* Barra horizontal superior */}
        <path
          d="M6 4 L44 4 L40 14 L18 14 L18 4 Z"
          fill="url(#fs-chrome)"
        />
        {/* Barra horizontal do meio */}
        <path
          d="M18 20 L36 20 L33 30 L18 30 L18 20 Z"
          fill="url(#fs-chrome)"
        />
        {/* Detalhe azul (sombra decorativa embaixo do F, marca registrada Formsteel) */}
        <path
          d="M6 32 L14 32 L14 48 L6 48 Z"
          fill="url(#fs-blue)"
          opacity="0.85"
        />
        {/* Highlight branco no topo pra dar brilho cromado */}
        <path
          d="M6 4 L18 4 L18 8 L6 8 Z"
          fill="#FFFFFF"
          opacity="0.35"
        />
      </svg>
      {showText && <span className="fs-logo-text">FORMSTEEL</span>}
    </div>
  );
}
